// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + ({"6571":"point_admin","6603":"sponsor"}[chunkId] || chunkId) + "." + {"4541":"8266fc88","6571":"319ad6c4","6603":"319ad6c4"}[chunkId] + ".chunk.css";
};